import { render, staticRenderFns } from "./CtrlBtns.vue?vue&type=template&id=7516ae9d&scoped=true&"
import script from "./CtrlBtns.vue?vue&type=script&lang=js&"
export * from "./CtrlBtns.vue?vue&type=script&lang=js&"
import style0 from "./CtrlBtns.vue?vue&type=style&index=0&id=7516ae9d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7516ae9d",
  null
  
)

export default component.exports